import { TMachineDescriptionDTO } from '@monorepo/types';
import { ModifiersZTableModel } from '../../table.modifier';

export const FLOATING_AREA_MACHINE_LIST_TABLE_MODEL = {
  createModel: (items: TMachineDescriptionDTO[]) => {
    return ModifiersZTableModel.createTableModel(
      items,
      {
        padding: 8,
        headerConfig: [
          { type: 'TEXT_CELL', text: 'table_model.MACHINESERIALID' },
          { type: 'TEXT_CELL', text: 'table_model.MACHINETYPE' },
          { type: 'TEXT_CELL', text: 'table_model.CATEGORY' },
          { type: 'TEXT_CELL', text: 'table_model.SUB-CATEGORY' },
          { type: 'TEXT_CELL', text: 'table_model.MACHINEMODELNO' },
        ],
      },
      (item) => ({
        type: 'ROW',
        rowItem: item,
        cells: [
          { type: 'TEXT_CELL', text: item.factorySerialNumber },
          { type: 'TEXT_CELL', text: item.machineType },
          { type: 'TEXT_CELL', text: item.machineCategory },
          { type: 'TEXT_CELL', text: item.machineSubCategory ?? '--' },
          { type: 'TEXT_CELL', text: item.machineModelNumber ?? '--' },
        ],
      }),
    );
  },
};
